import React from 'react';
import Section from './Section';

const Register = () => {
  return (
    <Section id="register" title="Registration">
      <p>
        The registration portal will open on 0xDay. Get ready to join the most exciting hackathon of the year! 
        A link to the registration form will be available here soon.
      </p>
    </Section>
  );
};

export default Register;
